import axios from 'axios'
import { Message } from 'element-ui'
import router from 'vue-router'
// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//   // todo 开发环境
//   // axios.defaults.baseURL = 'https://admin.zxfast.com'
// } else if (process.env.NODE_ENV == 'debug') {
//   // todo 调试环境
//   // axios.defaults.baseURL = 'https://admin.zxfast.com'
// } else if (process.env.NODE_ENV == 'production') {
//   // todo 生产环境
//   axios.defaults.baseURL = 'https://www.yuanhousheji.com'
// }
axios.defaults.timeout = 5000
// axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
const service = axios.create()
// Request interceptors
service.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('Finance-Jwt-Token')
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // config.data = 
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  response => {
    // code == OK: 成功
    const res = response.data
    // console.log(res.Code)
    if (res.Code !== 200) {
      // console.log(res.data)
      // 全局错误提示
      Message({
        message: res.Msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    console.log(error)
    let status = error.response.status || error
    let message = ''
    if (status === 403) {
      Message({
        message: '没有操作权限',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      switch (status) {
        case 302:
          if (window.location.hash !== '#/login') {
            sessionStorage.removeItem('MENU')
            location.reload()
          }
          break;
        case 400:
          message = '请求错误(400)'
          break;
        case 401:
          if (window.location.hash !== '#/login') {
            sessionStorage.removeItem('MENU')
            location.reload()
          }
          break;
        case 403:
          message = '拒绝访问(403)'
          break;
        case 404:
          message = '请求出错(404)'
          break;
        case 408:
          message = '请求超时(408)'
          break;
        case 500:
          message = '服务器错误(500)'
          break;
        case 502:
          message = '网络错误(502)'
          break;
        case 501:
          message = '服务未实现(501)'
          break;
        case 503:
          message = '服务不可用(503)'
          break;
        case 504:
          message = '网络超时(504)'
          break;
        case 505:
          message = 'HTTP版本不受支持(505)'
          break;
      }
      Message({
        message: error.response.data.message || message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error.response)
  }
)

export default service
